import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { DialogSessionTimeoutData } from 'src/app/dialogs/session-timeout/models/dialog-session-timeout-data';
import { SessionTimeoutComponent } from 'src/app/dialogs/session-timeout/session-timeout.component';
import { AttributesSelectionComponent } from '../controls/attributes-selection/attributes-selection.component';
import { AttributesSelectionData } from '../controls/attributes-selection/models/attributes-selection-data';
import { ForceConnectionComponent } from '../controls/force-connection/force-connection.component';
import { DialogForceConnectionData } from '../controls/force-connection/models/dialog-force-connection-data';
import { ContactsDialogComponent } from '../dialogs/contacts/contacts-dialog.component';
import { ContactDataType } from '../dialogs/contacts/models/contact-data-type';
import { DialogContactsData } from '../dialogs/contacts/models/dialog-contacts-data';
import { OrganizationActivationDialogData } from '../dialogs/organization-activation-dialog/models/organization-activation-dialog-data';
import { OrganizationActivationDialogComponent } from '../dialogs/organization-activation-dialog/organization-activation-dialog';
import { Attribute } from '../models/attribute';
import { Organization } from '../models/organization';

/**
 * Service utilisé pour gérer l'affichage des boites de dialogue.
 */
@Injectable({
    providedIn: 'root',
})
export class DialogService {
    /**
     * Constructeur.
     * @param dialog
     */
    constructor(public dialog: MatDialog) {}

    /**
     * Ferme toutes les boites de dialogue ouvertes.
     */
    public closeAll() {
        console.log('close all dialogs');
        this.dialog.closeAll();
    }

    /**
     * Ouvre la boite de dialogue d'expiration de session.
     * @param sessionTimeout : Date d'expiration de la session.
     * @param sessionNotificationDelay :  Delai (en secondes) avant l'expiration de la session pour afficher la notification à l'utilisateur.
     */
    public openSessionTimeout(sessionTimeout: Date, sessionNotificationDelay: number): Observable<boolean> {
        const dialogRef = this.dialog.open(SessionTimeoutComponent, {
            data: new DialogSessionTimeoutData(sessionTimeout, sessionNotificationDelay),
            panelClass: 'empty-dialog',
            ariaModal: true,
            disableClose: true,
        });

        return dialogRef.afterClosed();
    }

    /**
     * Ouvre la boite de dialogue des contacts.
     * @returns Un observable indiquant la fermeture de la boite de dialogue.
     */
    public openContacts(dataType: ContactDataType) {
        const dialogRef = this.dialog.open(ContactsDialogComponent, {
            data: new DialogContactsData(dataType),
            width: '1200px',
            panelClass: 'empty-dialog',
        });

        return dialogRef.afterClosed();
    }

    /**
     * Ouvre la boite de dialogue de confirmation de connexion forcée.
     * @param login login de l'utilisateur.
     */
    public openForceConnection(login: string) {
        const dialogRef = this.dialog.open(ForceConnectionComponent, {
            data: new DialogForceConnectionData(login),
            panelClass: 'empty-dialog',
        });

        return dialogRef.afterClosed();
    }

    public openAttributesSelection(attributes: Attribute[]) {
        const dialogRef = this.dialog.open(AttributesSelectionComponent, {
            data: {
                attributes: attributes,
            } as AttributesSelectionData,
            panelClass: 'empty-dialog',
        });

        return dialogRef.afterClosed();
    }

    public openOrganizationActivationDialog(organizations: Organization[]): Observable<OrganizationActivationDialogData> {
        const dialogRef = this.dialog.open(OrganizationActivationDialogComponent, {
            data: new OrganizationActivationDialogData(organizations),
            panelClass: 'empty-dialog',
        });

        return dialogRef.afterClosed();
    }
}
